export default __webpack_public_path__ + "static/media/vector_iD_icon.83064add.svg";